import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actionCreators } from '../actions/globalAction';
import { getOptions } from '../components/options/istAllYears';
import { data } from '../components/data/istAllYears';
import { ist } from '../components/objects/istAllYears';
import { Loader } from '../components/solar/Loader';
import { StatCard, StatCardSkeleton } from '../components/solar/StatCard';
import { ChartCardSkeleton } from '../components/solar/ChartCardSkeleton';
import { Bar } from 'react-chartjs-2';
import { Card } from 'react-bootstrap';


class ISTAllYearsClass extends Component {
    componentDidMount() {
        for (var k in ist) {
            this.props.request(ist[k]);
        }
    }

    render() {
        return (
            <div>
                <Loader show={!this.props.isLoaded} />
                <h3>Jahresertrag — Übersicht</h3>
                {renderKPIRow(this.props)}
                {renderUIGesamt(this.props)}
            </div>
        );
    }
}

/**
 * KPI-Zeile: Gesamtertrag aller Jahre, Beste Jahr, Durchschnitt pro Jahr, Erreichungsquote
 * als StatCards über dem Chart.
 */
function renderKPIRow(props) {
    const apiData = props.MixedBarDiagrammIstAllYearsUI || {};
    // BOTH isLoaded=true UND Daten vorhanden — nicht nur auf die Flag verlassen!
    let hasData = typeof (apiData.Soll) !== 'undefined' && apiData.Soll.length > 0;

    if (!props.isLoaded || !hasData) {
        return (
            <div className="stat-cards-row">
                <StatCardSkeleton variant="energy" />
                <StatCardSkeleton />
                <StatCardSkeleton />
                <StatCardSkeleton variant="progress" />
            </div>
        );
    }

    const years = apiData.Year || [];
    const sollArr = apiData.Soll || [];
    const istArr = apiData.Ist || [];

    // Gesamtertrag aller Jahre (Summe der Ist-Werte)
    let gesamtIst = 0;
    for (let i = 0; i < istArr.length; i++) {
        gesamtIst += Number(istArr[i]) || 0;
    }

    // Beste Jahr finden
    let bestJahr = '-';
    let bestWert = 0;
    for (let i = 0; i < istArr.length; i++) {
        const wert = Number(istArr[i]) || 0;
        if (wert > bestWert) {
            bestWert = wert;
            bestJahr = years[i] || '-';
        }
    }

    // Durchschnitt pro Jahr
    const durchschn = istArr.length > 0 ? Math.round(gesamtIst / istArr.length) : 0;

    // Erreichungsquote (Durchschnitt aller Jahre)
    let gesamtQuote = 0;
    let quoteCount = 0;
    for (let i = 0; i < sollArr.length; i++) {
        const sollVal = Number(sollArr[i]) || 0;
        const istVal = Number(istArr[i]) || 0;
        if (sollVal > 0) {
            gesamtQuote += (istVal / sollVal) * 100;
            quoteCount++;
        }
    }
    const avgQuote = quoteCount > 0 ? Math.round(gesamtQuote / quoteCount) : 0;

    return (
        <div className="stat-cards-row">
            <StatCard
                value={Math.round(gesamtIst).toLocaleString('de-DE')}
                label={'Gesamtertrag (' + years.length + ' Jahre)'}
                unit=" kWh"
                icon={<i className="bi bi-sun-fill" />}
                variant="energy"
                description="Summierte Erträge aller verfügbaren Jahre. Gibt die Gesamtproduktion der Anlage wieder."
            />
            <StatCard
                value={Math.round(bestWert).toLocaleString('de-DE')}
                label={'Rekordjahr ' + bestJahr}
                unit=" kWh"
                icon={<i className="bi bi-trophy-fill" />}
                description="Bestes aller Jahre. Zeigt das Jahr mit dem höchsten PV-Ertrag und den dazugehörigen Wert."
            />
            <StatCard
                value={durchschn.toLocaleString('de-DE')}
                label="Durchschnitt pro Jahr"
                unit=" kWh"
                icon={<i className="bi bi-graph-up" />}
                description="Mittlerer jährlicher Ertrag aller Jahre. Gute Orientierung für den zu erwartenden Jahreswert."
            />
            <StatCard
                value={avgQuote}
                label="Erreichungsquote"
                unit=" %"
                icon={<i className="bi bi-bullseye" />}
                variant={avgQuote >= 100 ? 'energy' : avgQuote >= 75 ? 'progress' : 'consumption'}
                description="Durchschnittliches Verhältnis von Ist zu Soll über alle Jahre. Langfristige Performance-Kennzahl."
            />
        </div>
    );
}

function renderUIGesamt(props) {
    let MixedBarDiagrammIstAllYearsUI = props.MixedBarDiagrammIstAllYearsUI || {}
    let hasData = typeof (MixedBarDiagrammIstAllYearsUI.Soll) !== 'undefined';

    let chartData = { labels: [''], datasets: [{ data: [0] }, { data: [0] }] }

    if (hasData) {
        chartData = {
            labels: MixedBarDiagrammIstAllYearsUI.Year,
            datasets: [
                { ...data.datasets[0], data: MixedBarDiagrammIstAllYearsUI.Soll },
                { ...data.datasets[1], data: MixedBarDiagrammIstAllYearsUI.Ist }
            ]
        };
    }

    // Skelett so lange zeigen, BIS BOTH isLoaded=true UND Daten vorhanden!
    let loading = !props.isLoaded || !hasData;

    return (
        <>
            {loading && <ChartCardSkeleton />}
            {!loading && (
                <Card className="chart-card">
                    <Card.Body>
                        <Bar data={chartData} options={{ ...getOptions(), animation: false }} />
                    </Card.Body>
                </Card>
            )}
        </>
    );
}

export default connect(
    state => state.istAllYearsReducer,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(ISTAllYearsClass);